import React, { useRef, useState } from "react";
import { Navigator, TopBanner, TopNavBar } from "../../components/TopNavBar";
import { useSelector } from "react-redux";
import { selectBuilding } from "../../features/store";
import { Card } from "../../components/General";
import CurrentEvent from "../dashboard/CurrentEvent";
import RoomInfo from "./RoomInfo";
import FootfallBarChart from "./FootfallBarChart";
import EventBarChart from "./EventBarChart";
import FootfallLineChart from "./FootfallLineChart";

const Main = ({ selectedBuilding, setSelectedBuilding }) => {
    const [scrollTop, setScrollTop] = useState(0);
    const buildings = useSelector(selectBuilding);
    const roomInfoRef = useRef(null);
    const currEventRef = useRef(null);
    const footfallHourRef = useRef(null);
    const footfallCumulativeRef = useRef(null);
    const eventRef = useRef(null);

    return (
        <>
            <div
                className="main"
                onScroll={(e) => {
                    setScrollTop(e.currentTarget.scrollTop);
                }}
            >
                <TopNavBar
                    shadow={scrollTop !== 0}
                    buildingDict={buildings}
                    selectedBuilding={selectedBuilding}
                    setSelectedBuilding={setSelectedBuilding}
                ></TopNavBar>
                <div className="main-content">
                    {Object.keys(buildings).length !== 0 ? (
                        <>
                            <TopBanner
                                title={buildings[selectedBuilding].buildingName}
                                navigator={
                                    <Navigator
                                        refs={[
                                            roomInfoRef,
                                            currEventRef,
                                            footfallHourRef,
                                            footfallCumulativeRef,
                                            eventRef,
                                        ]}
                                        names={[
                                            "Room Info",
                                            "Current Events",
                                            "Footfall ( Hourly Total )",
                                            "Footfall ( Cumulative )",
                                            "Event",
                                        ]}
                                    />
                                }
                            ></TopBanner>

                            <div className="main-non-banner">
                                <Card header={"Room Information"} forwardRef={roomInfoRef}>
                                    <RoomInfo currBuilding={buildings[selectedBuilding]} />
                                </Card>
                                <Card header={"Current Events"} forwardRef={currEventRef}>
                                    <CurrentEvent currBuilding={buildings[selectedBuilding]}></CurrentEvent>
                                </Card>
                                <Card header={"Footfall ( Hourly Total )"} forwardRef={footfallHourRef}>
                                    <FootfallLineChart selectedBuilding={selectedBuilding} />
                                </Card>
                                <Card header={"Footfall ( Cumulative )"} forwardRef={footfallCumulativeRef}>
                                    <FootfallBarChart selectedBuilding={selectedBuilding} />
                                </Card>
                                <Card header={"Event"} forwardRef={eventRef}>
                                    <EventBarChart selectedBuilding={selectedBuilding} />
                                </Card>
                            </div>
                        </>
                    ) : (
                        <div className="main-non-banner">
                            <h4> No room available</h4>
                            <p>Please contact admin for room access.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Main;
